<template>
  <div class="animated fadeIn">
    <div class="card shadow-sm border-0">
      <div class="card-header bg-dark text-white d-flex align-items-center justify-content-between py-2">
        <h6 class="mb-0"><font-awesome-icon icon="calendar" /> Holidays</h6>
        <b-button variant="success" size="sm" @click="openAdd">
          <font-awesome-icon icon="plus" /> Add Holiday
        </b-button>
      </div>
      <div class="card-body position-relative">
        <b-input-group class="mb-3" size="sm">
          <b-input-group-prepend>
            <b-input-group-text class="bg-dark text-white"><font-awesome-icon icon="search" /></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input v-model="search" placeholder="Search name or date" debounce="400" @update="getAll"></b-form-input>
        </b-input-group>

        <b-table
          responsive hover striped bordered small
          :items="list.data" :fields="fields" :busy="loading" show-empty head-variant="dark"
        >
          <template v-slot:cell(date)="data">
            <strong>{{ data.item.formatted_date.other_formats.format_1 }}</strong>
          </template>
          <template v-slot:cell(type)="data">
            <b-badge :variant="data.item.type == 1 ? 'primary' : 'info'">{{ data.item.type_description }}</b-badge>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <b-button variant="outline-primary" size="sm" @click="openEdit(data.item)"><font-awesome-icon icon="edit" /></b-button>
              <b-button variant="outline-danger" size="sm" @click="remove(data.item)"><font-awesome-icon icon="minus-circle" /></b-button>
            </div>
          </template>
        </b-table>

        <nav v-if="list.total > 0">
          <b-pagination :disabled="loading" @input="getAll" align="right"
            :total-rows="parseInt(list.total)" :per-page="parseInt(list.per_page)"
            v-model="list.current_page" class="mb-0"></b-pagination>
        </nav>
      </div>
    </div>

    <b-modal v-model="modal" centered size="md" :hide-footer="true" :title="form.id ? 'Edit Holiday' : 'Add Holiday'">
      <b-form @submit.prevent="save">
        <b-form-group label="Date">
          <b-form-input type="date" v-model="form.date" required></b-form-input>
        </b-form-group>
        <b-form-group label="Name">
          <b-form-input v-model="form.name" required placeholder="e.g. Independence Day"></b-form-input>
        </b-form-group>
        <b-form-group label="Type">
          <select class="form-control" v-model="form.type" required>
            <option :value="1">Regular Holiday</option>
            <option :value="2">Special Non-Working Holiday</option>
          </select>
        </b-form-group>
        <b-button type="submit" variant="success" block><font-awesome-icon icon="save" /> Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import SwalMixin from '@/views/mixins/Swal.js'

  export default {
    name: 'Holidays',
    mixins: [SwalMixin],
    data() {
      return {
        loading: true,
        search: '',
        list: { data: [], current_page: 1, total: 0, per_page: 1 },
        fields: [
          { key: 'date', label: 'Date' },
          { key: 'name', label: 'Name' },
          { key: 'type', label: 'Type' },
          { key: 'action', label: '' },
        ],
        modal: false,
        form: { id: null, date: '', name: '', type: 1 },
      }
    },
    created() {
      this.getAll();
    },
    methods: {
      getAll() {
        this.loading = true;
        this.axios.get('holidays/all', { params: { page: this.list.current_page, per_page: 25, search: this.search } })
          .then(response => { this.list = response.data; this.loading = false; })
          .catch(error => { console.log(error); this.loading = false; });
      },
      openAdd() {
        this.form = { id: null, date: '', name: '', type: 1 };
        this.modal = true;
      },
      openEdit(item) {
        this.form = { id: item.id, date: (item.date || '').substring(0, 10), name: item.name, type: item.type };
        this.modal = true;
      },
      save() {
        this.axios.post('holidays/save', this.form).then(response => {
          this.modal = false;
          this.swalTransactionCompleted();
          this.getAll();
        }).catch(error => {
          this.swal_transaction_error_data.text = (error.response && error.response.data) ? error.response.data : 'Something went wrong.';
          this.swalRequestError();
        });
      },
      remove(item) {
        this.swalConfirmDelete((data) => {
          if (data.value) {
            this.axios.delete('holidays/delete', { data: { id: item.id } }).then(response => {
              this.swalTransactionCompleted();
              this.getAll();
            }).catch(error => {
              this.swalRequestError();
            });
          }
        });
      }
    }
  }
</script>
